'use strict';

var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var EventEmitter = require('events').EventEmitter;

var Readable = require('readable-stream');

var mapSeries = require('p-each-series');

var Log = require('ipfs-log');

var Index = require('./Index');

var Replicator = require('./Replicator');

var ReplicationInfo = require('./replication-info');

var Logger = require('logplease');

var logger = Logger.create("orbit-db.store", {
  color: Logger.Colors.Blue
});
Logger.setLogLevel('ERROR');
var DefaultOptions = {
  Index: Index,
  maxHistory: -1,
  path: './orbitdb',
  replicate: true,
  referenceCount: 64,
  replicationConcurrency: 128
};

var Store =
/*#__PURE__*/
function () {
  function Store(ipfs, peerId, address, options) {
    var _this = this;

    _classCallCheck(this, Store);

    // Set the options
    var opts = Object.assign({}, DefaultOptions);
    Object.assign(opts, options);
    this.options = opts; // Default type

    this._type = 'store'; // Create IDs, names and paths

    this.id = address.toString();
    this.uid = peerId;
    this.address = address;
    this.dbname = address.path || '';
    this.events = new EventEmitter(); // External dependencies

    this._ipfs = ipfs;
    this._cache = options.cache;
    this._keystore = options.keystore;
    this._key = options && options.key ? options.key : this._keystore.getKey(peerId) || this._keystore.createKey(peerId); // FIX: duck typed interface

    this._ipfs.keystore = this._keystore; // Access mapping

    var defaultAccess = {
      admin: [this._key.getPublic('hex')],
      read: [],
      // Not used atm, anyone can read
      write: [this._key.getPublic('hex')]
    };
    this.access = options.accessController || defaultAccess; // Create the operations log

    this._oplog = new Log(this._ipfs, this.id, null, null, null, this._key, this.access.write); // Create the index

    this._index = new this.options.Index(this.uid); // Replication progress info

    this._replicationStatus = new ReplicationInfo(); // Statistics

    this._stats = {
      snapshot: {
        bytesLoaded: -1
      },
      syncRequestsReceieved: 0
    };

    try {
      this._replicator = new Replicator(this, this.options.replicationConcurrency); // For internal backwards compatibility,
      // to be removed in future releases

      this._loader = this._replicator;

      this._replicator.on('load.added', function (entry) {
        // Update the latest entry state (latest is the entry with largest clock time)
        _this._replicationStatus.queued++;

        _this._recalculateReplicationMax(entry.clock ? entry.clock.time : 0); // logger.debug(`<replicate>`)


        _this.events.emit('replicate', _this.address.toString(), entry);
      });

      this._replicator.on('load.progress', function (id, hash, entry, have, bufferedLength) {
        if (_this._replicationStatus.buffered > bufferedLength) {
          _this._recalculateReplicationProgress(_this.replicationStatus.progress + bufferedLength);
        } else {
          _this._recalculateReplicationProgress(_this._oplog.length + bufferedLength);
        }

        _this._replicationStatus.buffered = bufferedLength;

        _this._recalculateReplicationMax(_this.replicationStatus.progress); // logger.debug(`<replicate.progress>`)


        _this.events.emit('replicate.progress', _this.address.toString(), hash, entry, _this.replicationStatus.progress, _this.replicationStatus.max);
      });

      var onLoadCompleted =
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(logs, have) {
          var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, log, heads;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 4;
                  _iterator = logs[Symbol.iterator]();

                case 6:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context.next = 13;
                    break;
                  }

                  log = _step.value;
                  _context.next = 10;
                  return _this._oplog.join(log);

                case 10:
                  _iteratorNormalCompletion = true;
                  _context.next = 6;
                  break;

                case 13:
                  _context.next = 19;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t0 = _context["catch"](4);
                  _didIteratorError = true;
                  _iteratorError = _context.t0;

                case 19:
                  _context.prev = 19;
                  _context.prev = 20;

                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }

                case 22:
                  _context.prev = 22;

                  if (!_didIteratorError) {
                    _context.next = 25;
                    break;
                  }

                  throw _iteratorError;

                case 25:
                  return _context.finish(22);

                case 26:
                  return _context.finish(19);

                case 27:
                  _this._replicationStatus.queued -= logs.length;
                  _this._replicationStatus.buffered = _this._replicator._buffer.length;
                  _context.next = 31;
                  return _this._updateIndex();

                case 31:
                  //only store heads that has been verified and merges
                  heads = _this._oplog.heads;
                  _context.next = 34;
                  return _this._cache.set('_remoteHeads', heads);

                case 34:
                  logger.debug("Saved heads ".concat(heads.length, " [").concat(heads.map(function (e) {
                    return e.hash;
                  }).join(', '), "]")); // logger.debug(`<replicated>`)

                  _this.events.emit('replicated', _this.address.toString(), logs.length);

                  _context.next = 41;
                  break;

                case 38:
                  _context.prev = 38;
                  _context.t1 = _context["catch"](0);
                  console.error(_context.t1);

                case 41:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[0, 38], [4, 15, 19, 27], [20,, 22, 26]]);
        }));

        return function onLoadCompleted(_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();

      this._replicator.on('load.end', onLoadCompleted);
    } catch (e) {
      console.error("Store Error:", e);
    }
  }

  _createClass(Store, [{
    key: "close",
    value: function () {
      var _close = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.options.onClose) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.options.onClose(this.address.toString());

              case 3:
                //Replicator teardown logic
                this._replicator.stop(); // Reset replication statistics


                this._replicationStatus.reset(); // Reset database statistics


                this._stats = {
                  snapshot: {
                    bytesLoaded: -1
                  },
                  syncRequestsReceieved: 0 // Remove all event listeners

                };
                this.events.removeAllListeners('load');
                this.events.removeAllListeners('load.progress');
                this.events.removeAllListeners('replicate');
                this.events.removeAllListeners('replicate.progress');
                this.events.removeAllListeners('replicated');
                this.events.removeAllListeners('ready');
                this.events.removeAllListeners('write'); // Close cache

                _context2.next = 15;
                return this._cache.close();

              case 15:
                // Database is now closed
                // TODO: afaik we don't use 'closed' event anymore,
                // to be removed in future releases
                this.events.emit('closed', this.address.toString());
                return _context2.abrupt("return", Promise.resolve());

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function close() {
        return _close.apply(this, arguments);
      };
    }()
    /**
     * Drops a database and removes local data
     * @return {[None]}
     */

  }, {
    key: "drop",
    value: function () {
      var _drop = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.close();

              case 2:
                _context3.next = 4;
                return this._cache.destroy();

              case 4:
                // Reset
                this._index = new this.options.Index(this.uid);
                this._oplog = new Log(this._ipfs, this.id, null, null, null, this._key, this.access.write);
                this._cache = this.options.cache;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function drop() {
        return _drop.apply(this, arguments);
      };
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(amount) {
        var _this2 = this;

        var localHeads, remoteHeads, heads;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                amount = amount || this.options.maxHistory;
                _context5.next = 3;
                return this._cache.get('_localHeads');

              case 3:
                _context5.t0 = _context5.sent;

                if (_context5.t0) {
                  _context5.next = 6;
                  break;
                }

                _context5.t0 = [];

              case 6:
                localHeads = _context5.t0;
                _context5.next = 9;
                return this._cache.get('_remoteHeads');

              case 9:
                _context5.t1 = _context5.sent;

                if (_context5.t1) {
                  _context5.next = 12;
                  break;
                }

                _context5.t1 = [];

              case 12:
                remoteHeads = _context5.t1;
                heads = localHeads.concat(remoteHeads);
                if (heads.length > 0) this.events.emit('load', this.address.toString(), heads);
                _context5.next = 17;
                return mapSeries(heads,
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4(head) {
                    var log;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _this2._recalculateReplicationMax(head.clock.time);

                            _context4.next = 3;
                            return Log.fromEntryHash(_this2._ipfs, head.hash, _this2._oplog.id, amount, _this2._oplog.values, _this2._key, _this2.access.write, _this2._onLoadProgress.bind(_this2));

                          case 3:
                            log = _context4.sent;
                            _context4.next = 6;
                            return _this2._oplog.join(log, amount);

                          case 6:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, this);
                  }));

                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 17:
                if (!(heads.length > 0)) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 20;
                return this._updateIndex();

              case 20:
                this.events.emit('ready', this.address.toString(), this._oplog.heads);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      return function load(_x3) {
        return _load.apply(this, arguments);
      };
    }()
  }, {
    key: "sync",
    value: function sync(heads) {
      var _this3 = this;

      this._stats.syncRequestsReceieved += 1;
      logger.debug("Sync request #".concat(this._stats.syncRequestsReceieved, " ").concat(heads.length));
      if (heads.length === 0) return; // To simulate network latency, uncomment this line
      // and comment out the rest of the function
      // That way the object (received as head message from pubsub)
      // doesn't get written to IPFS and so when the Replicator is fetching
      // the log, it'll fetch it from the network instead from the disk.
      // return this._replicator.load(heads)

      var saveToIpfs = function saveToIpfs(head) {
        if (!head) {
          console.warn("Warning: Given input entry was 'null'.");
          return Promise.resolve(null);
        }

        if (!_this3.access.write.includes(head.key) && !_this3.access.write.includes('*')) {
          console.warn("Warning: Given input entry is not allowed in this log and was discarded (no write access).");
          return Promise.resolve(null);
        } // TODO: verify the entry's signature here


        var logEntry = Object.assign({}, head);
        logEntry.hash = null;
        return _this3._ipfs.object.put(Buffer.from(JSON.stringify(logEntry))).then(function (dagObj) {
          return dagObj.toJSON().multihash;
        }).then(function (hash) {
          // We need to make sure that the head message's hash actually
          // matches the hash given by IPFS in order to verify that the
          // message contents are authentic
          if (hash !== head.hash) {
            console.warn('"WARNING! Head hash didn\'t match the contents');
          }

          return hash;
        }).then(function () {
          return head;
        });
      };

      return mapSeries(heads, saveToIpfs).then(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6(saved) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.abrupt("return", _this3._replicator.load(saved.filter(function (e) {
                    return e !== null;
                  })));

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        return function (_x5) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "loadMoreFrom",
    value: function loadMoreFrom(amount, entries) {
      this._replicator.load(entries);
    }
  }, {
    key: "saveSnapshot",
    value: function () {
      var _saveSnapshot = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var unfinished, snapshotData, header, rs, size, bytes, addToStream, snapshot;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                unfinished = this._replicator.getQueue();
                snapshotData = this._oplog.toSnapshot();
                header = new Buffer(JSON.stringify({
                  id: snapshotData.id,
                  heads: snapshotData.heads,
                  size: snapshotData.values.length,
                  type: this.type
                }));
                rs = new Readable();
                size = new Uint16Array([header.length]);
                bytes = new Buffer(size.buffer);
                rs.push(bytes);
                rs.push(header);

                addToStream = function addToStream(val) {
                  var str = new Buffer(JSON.stringify(val));
                  var size = new Uint16Array([str.length]);
                  rs.push(new Buffer(size.buffer));
                  rs.push(str);
                };

                snapshotData.values.forEach(addToStream);
                rs.push(null); // tell the stream we're finished

                _context7.next = 13;
                return this._ipfs.files.add(rs);

              case 13:
                snapshot = _context7.sent;
                _context7.next = 16;
                return this._cache.set('snapshot', snapshot[snapshot.length - 1]);

              case 16:
                _context7.next = 18;
                return this._cache.set('queue', unfinished);

              case 18:
                logger.debug("Saved snapshot: ".concat(snapshot[snapshot.length - 1].hash, ", queue length: ").concat(unfinished.length));
                return _context7.abrupt("return", snapshot);

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      return function saveSnapshot() {
        return _saveSnapshot.apply(this, arguments);
      };
    }()
  }, {
    key: "loadFromSnapshot",
    value: function () {
      var _loadFromSnapshot = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(onProgressCallback) {
        var _this4 = this;

        var maxClock, queue, snapshot, res, loadSnapshotData, onProgress, snapshotData, log;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.events.emit('load', this.address.toString());

                maxClock = function maxClock(res, val) {
                  return Math.max(res, val.clock.time);
                };

                _context8.next = 4;
                return this._cache.get('queue');

              case 4:
                queue = _context8.sent;
                this.sync(queue || []);
                _context8.next = 8;
                return this._cache.get('snapshot');

              case 8:
                snapshot = _context8.sent;

                if (!snapshot) {
                  _context8.next = 31;
                  break;
                }

                _context8.next = 12;
                return this._ipfs.files.catReadableStream(snapshot.hash);

              case 12:
                res = _context8.sent;

                loadSnapshotData = function loadSnapshotData() {
                  return new Promise(function (resolve, reject) {
                    var buf = new Buffer(0);
                    var q = [];

                    var bufferData = function bufferData(d) {
                      _this4._byteSize += d.length;

                      if (q.length < 20000) {
                        q.push(d);
                      } else {
                        var a = Buffer.concat(q);
                        buf = Buffer.concat([buf, a]);
                        q = [];
                      }
                    };

                    var done = function done() {
                      if (q.length > 0) {
                        var _a = Buffer.concat(q);

                        buf = Buffer.concat([buf, _a]);
                      }

                      function toArrayBuffer(buf) {
                        var ab = new ArrayBuffer(buf.length);
                        var view = new Uint8Array(ab);

                        for (var i = 0; i < buf.length; ++i) {
                          view[i] = buf[i];
                        }

                        return ab;
                      }

                      var headerSize = parseInt(new Uint16Array(toArrayBuffer(buf.slice(0, 2))));
                      var header;

                      try {
                        header = JSON.parse(buf.slice(2, headerSize + 2));
                      } catch (e) {// TODO
                      }

                      var values = [];
                      var a = 2 + headerSize;

                      while (a < buf.length) {
                        var s = parseInt(new Uint16Array(toArrayBuffer(buf.slice(a, a + 2))));
                        a += 2;
                        var data = buf.slice(a, a + s);

                        try {
                          var d = JSON.parse(data);
                          values.push(d);
                        } catch (e) {}

                        a += s;
                      }

                      if (header) {
                        _this4._type = header.type;
                        resolve({
                          values: values,
                          id: header.id,
                          heads: header.heads,
                          type: header.type
                        });
                      } else {
                        resolve({
                          values: values,
                          id: null,
                          heads: null,
                          type: null
                        });
                      }
                    };

                    res.on('data', bufferData);
                    res.on('end', done);
                  });
                };

                onProgress = function onProgress(hash, entry, count, total) {
                  _this4._recalculateReplicationStatus(count, entry.clock.time);

                  _this4._onLoadProgress(hash, entry);
                }; // Fetch the entries
                // Timeout 1 sec to only load entries that are already fetched (in order to not get stuck at loading)


                _context8.next = 17;
                return loadSnapshotData();

              case 17:
                snapshotData = _context8.sent;

                this._recalculateReplicationMax(snapshotData.values.reduce(maxClock, 0));

                if (!snapshotData) {
                  _context8.next = 28;
                  break;
                }

                _context8.next = 22;
                return Log.fromJSON(this._ipfs, snapshotData, -1, this._key, this.access.write, 1000, onProgress);

              case 22:
                log = _context8.sent;
                _context8.next = 25;
                return this._oplog.join(log);

              case 25:
                _context8.next = 27;
                return this._updateIndex();

              case 27:
                this.events.emit('replicated', this.address.toString());

              case 28:
                this.events.emit('ready', this.address.toString(), this._oplog.heads);
                _context8.next = 32;
                break;

              case 31:
                throw new Error("Snapshot for ".concat(this.address, " not found!"));

              case 32:
                return _context8.abrupt("return", this);

              case 33:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      return function loadFromSnapshot(_x6) {
        return _loadFromSnapshot.apply(this, arguments);
      };
    }()
  }, {
    key: "_updateIndex",
    value: function () {
      var _updateIndex2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this._recalculateReplicationMax();

                _context9.next = 3;
                return this._index.updateIndex(this._oplog);

              case 3:
                this._recalculateReplicationProgress();

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      return function _updateIndex() {
        return _updateIndex2.apply(this, arguments);
      };
    }()
  }, {
    key: "_addOperation",
    value: function () {
      var _addOperation2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(data, batchOperation, lastOperation, onProgressCallback) {
        var entry;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!this._oplog) {
                  _context10.next = 12;
                  break;
                }

                _context10.next = 3;
                return this._oplog.append(data, this.options.referenceCount);

              case 3:
                entry = _context10.sent;

                this._recalculateReplicationStatus(this.replicationStatus.progress + 1, entry.clock.time);

                _context10.next = 7;
                return this._cache.set('_localHeads', [entry]);

              case 7:
                _context10.next = 9;
                return this._updateIndex();

              case 9:
                this.events.emit('write', this.address.toString(), entry, this._oplog.heads);
                if (onProgressCallback) onProgressCallback(entry);
                return _context10.abrupt("return", entry.hash);

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      return function _addOperation(_x7, _x8, _x9, _x10) {
        return _addOperation2.apply(this, arguments);
      };
    }()
  }, {
    key: "_addOperationBatch",
    value: function _addOperationBatch(data, batchOperation, lastOperation, onProgressCallback) {
      throw new Error("Not implemented!");
    }
  }, {
    key: "_onLoadProgress",
    value: function _onLoadProgress(hash, entry, progress, total) {
      this._recalculateReplicationStatus(progress, total);

      this.events.emit('load.progress', this.address.toString(), hash, entry, this.replicationStatus.progress, this.replicationStatus.max);
    }
    /* Replication Status state updates */

  }, {
    key: "_recalculateReplicationProgress",
    value: function _recalculateReplicationProgress(max) {
      this._replicationStatus.progress = Math.max.apply(null, [this._replicationStatus.progress, this._oplog.length, max || 0]);

      this._recalculateReplicationMax(this.replicationStatus.progress);
    }
  }, {
    key: "_recalculateReplicationMax",
    value: function _recalculateReplicationMax(max) {
      this._replicationStatus.max = Math.max.apply(null, [this._replicationStatus.max, this._oplog.length, max || 0]);
    }
  }, {
    key: "_recalculateReplicationStatus",
    value: function _recalculateReplicationStatus(maxProgress, maxTotal) {
      this._recalculateReplicationProgress(maxProgress);

      this._recalculateReplicationMax(maxTotal);
    }
  }, {
    key: "all",
    get: function get() {
      var _this5 = this;

      return Array.isArray(this._index._index) ? this._index._index : Object.keys(this._index._index).map(function (e) {
        return _this5._index._index[e];
      });
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "key",
    get: function get() {
      return this._key;
    }
    /**
     * Returns the database's current replication status information
     * @return {[Object]} [description]
     */

  }, {
    key: "replicationStatus",
    get: function get() {
      return this._replicationStatus;
    }
  }]);

  return Store;
}();

module.exports = Store;